import React from "react";
import { Carousel } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css'; // Make sure Bootstrap CSS is imported
import slide1 from '../images/slide1.jpg'
import slide2 from '../images/slide2.jpg'
import slide3 from '../images/slide3.jpg'
import '../css/Home.css'
import { Card, Button, Container, Row, Col } from 'react-bootstrap';

const Home = () => {
  return (
    <div>
      <Carousel interval={3000}> {/* Change the interval to adjust scrolling speed */}
        <Carousel.Item>
          <img
            className="d-block w-100"
            src={slide1} // Replace with your image path
            alt="First slide"
          />
          <Carousel.Caption>
            <h3>First Slide Label</h3>
            <p>Description for the first slide.</p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src={slide2} // Replace with your image path
            alt="Second slide"
          />
          <Carousel.Caption>
            <h3>Second Slide Label</h3>
            <p>Description for the second slide.</p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src={slide3} // Replace with your image path
            alt="Third slide"
          />
          <Carousel.Caption>
            <h3>Third Slide Label</h3>
            <p>Description for the third slide.</p>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>

      <Container className="my-4">
        <Row>
          <Col xs={12}>
            <h2 className="text-center">Welcome to KUSAVINI BALAGA</h2>
            <div className="text-left paragraph-content">
              <p>
                KUSAVINI BALAGA is a vibrant cultural and community organization located in Bangalore, India, dedicated to the promotion and preservation of the Kannada language and culture. Established in the late 20th century, the organization emerged as a response to the growing need for a platform that would foster a sense of community among Kannada speakers, especially in an urban environment where linguistic and cultural identities often face challenges.
              </p>
              <p>
                The organization’s primary mission is to celebrate and propagate Kannada heritage through various initiatives. KUSAVINI BALAGA organizes a multitude of cultural events, including festivals, plays, music concerts, and literary gatherings that highlight the richness of Kannada traditions. These events serve not only as a means of entertainment but also as educational opportunities, allowing participants to engage deeply with their cultural roots.
              </p>
           
              <p>
                In conclusion, KUSAVINI BALAGA plays a crucial role in preserving and promoting the Kannada language and culture in Bangalore. Its diverse range of activities fosters a sense of belonging and pride among Kannada speakers, ensuring that the rich heritage of Karnataka continues to thrive in the modern world. By engaging the community through cultural events, educational initiatives, and social responsibility projects, KUSAVINI BALAGA exemplifies the spirit of community and cultural preservation.
              </p>
            </div>
          </Col>
        </Row>
      </Container>

      <div>
      <Container className="my-4">
        <Row>
          <Col xs={12} md={4} className="d-flex">
            <Card className="mb-3 flex-fill">
              <Card.Img variant="top" src={slide1} alt="Attend an Event" className="equal-img" />
              <Card.Body className="d-flex flex-column">
                <Card.Title>Attend an Event</Card.Title>
                <Card.Text>Learn, engage, and celebrate with fellow Brunonians.</Card.Text>
                <div className="mt-auto">
                  <Button variant="primary" href="#">Find Events</Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} md={4} className="d-flex">
            <Card className="mb-3 flex-fill">
              <Card.Img variant="top" src={slide2} alt="Give Back" className="equal-img" />
              <Card.Body className="d-flex flex-column">
                <Card.Title>Give Back</Card.Title>
                <Card.Text>Support Brown by making your 2022-23 gift by June 30.</Card.Text>
                <div className="mt-auto">
                  <Button variant="primary" href="#">Make Your Gift</Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} md={4} className="d-flex">
            <Card className="mb-3 flex-fill">
              <Card.Img variant="top" src={slide3} alt="Explore Communities" className="equal-img" />
              <Card.Body className="d-flex flex-column">
                <Card.Title>Explore Communities</Card.Title>
                <Card.Text>Expand your Brown experience by club, class, affinity, or cause.</Card.Text>
                <div className="mt-auto">
                  <Button variant="primary" href="#">Find Communities</Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
    </div>

    
  );
};

export default Home;
